import { createSlice } from '@reduxjs/toolkit';
import { t_medical_institution } from 'types';
import { getMedicalInstitution } from './thunk';

const initialState: t_medical_institution[] = [];

const medicalInstitutionSlices = createSlice({
  name: 'medicalInstitution',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getMedicalInstitution.fulfilled, (state, action) => {
      const data: any = action.payload;
      if (data) {
        return data.items;
      }
      return state;
    });
  },
});
export default medicalInstitutionSlices.reducer;
